import {
  DataService,
  ModalService,
  registerBulkAction,
} from '@vendure/admin-ui/core';
import { of, switchMap } from 'rxjs';

export const registerBulkEditBadgesAction = registerBulkAction({
  location: 'product-variant-list',
  label: 'Modify badge',
  icon: 'new',
  onClick: ({ injector, selection }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);

    modalService
      .dialog({
        title: `Set badge for ${selection.length} product variants`,
        buttons: [
          { type: 'secondary', label: 'Cancel' },
          { type: 'primary', label: 'New', returnValue: 'new' },
          {
            type: 'primary',
            label: 'Special Price',
            returnValue: 'special-price',
          },
          {
            type: 'primary',
            label: 'Remove all badges',
            returnValue: 'none',
          },
        ],
      })
      .pipe(
        switchMap((type) =>
          type
            ? dataService.product.updateProductVariants(
                selection.map((v) => ({
                  id: v.id,
                  customFields: { badge: type === 'none' ? null : type },
                })),
              )
            : of(undefined),
        ),
      )
      .subscribe();
  },
});
